import template from './sw-cms-block-text-two-column.html.twig';
import './sw-cms-block-text-two-column.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
